import {
  CUSTOMER_ALL_IN_TIERS_SPACE_PARAMETER_SUPPORT,
  useDealerInfluencedEntityAdminSpaceParameters,
} from '@src/components/AppLayout/Panels/Dealer/DealerSpaceParameters';
import { EntityAdmin, type AllInTier } from '@talos/kyoko';
import type { useCustomerPricingTiersShared } from './useCustomerPricingTiersShared';
import {
  CUSTOMER_ALL_IN_TIERS_PERSIST_KEY,
  CUSTOMER_PRICING_BASE_TIERS_TAB,
  CUSTOMER_PRICING_TIERS_ALL_IN_TIER_COLUMNS,
  CUSTOMER_PRICING_TIERS_ALL_IN_TIERS_BULK_EDIT_FIELDS,
  CUSTOMER_PRICING_TIERS_GROUP_COLUMN_DEF,
  getCustomerPricingTiersAllInTierPatchDeletePath,
  getCustomerPricingTiersAllInTierPostPath,
} from './utils';

export type CustomerAllInTiersProps = {
  shared: ReturnType<typeof useCustomerPricingTiersShared>;
  persistKey?: string;
};

/** Standalone All-in / Base Tiers EntityAdmin — used by the Pricing Tiers page and Spaces panels. */
export function CustomerAllInTiers({
  shared,
  persistKey = CUSTOMER_ALL_IN_TIERS_PERSIST_KEY,
}: CustomerAllInTiersProps) {
  const {
    canEditDealer,
    maxBulkEditRows,
    globalDefault,
    getAllInTiersDrawerOptions,
    allInTiersFilterableProperties,
    defaultPricingRuleAction,
    getChildEntityDisplayName,
  } = shared;
  const spaceParameterProps = useDealerInfluencedEntityAdminSpaceParameters(
    CUSTOMER_ALL_IN_TIERS_SPACE_PARAMETER_SUPPORT,
    allInTiersFilterableProperties
  );

  return (
    <EntityAdmin<AllInTier>
      title={CUSTOMER_PRICING_BASE_TIERS_TAB.label}
      subtitle="Set up your Base Tiers here."
      path="/all-in-tiers"
      queryParams={{ expanded: 'true' }}
      globalEntity={globalDefault}
      getPostPath={getCustomerPricingTiersAllInTierPostPath}
      getPatchPath={getCustomerPricingTiersAllInTierPatchDeletePath}
      columns={CUSTOMER_PRICING_TIERS_ALL_IN_TIER_COLUMNS}
      entityIDField="Tier"
      childIDField="Symbol"
      childEntityName="Symbol Override"
      getChildEntityDisplayName={getChildEntityDisplayName}
      getEntityDrawerOptions={getAllInTiersDrawerOptions}
      {...spaceParameterProps}
      entityName="Base Tier"
      allowAddEntity={canEditDealer}
      allowEditEntity={canEditDealer}
      allowDeleteEntity={canEditDealer}
      groupColumnDef={CUSTOMER_PRICING_TIERS_GROUP_COLUMN_DEF}
      persistKey={persistKey}
      useTabs={false}
      panelActions={[defaultPricingRuleAction]}
      allowBulkEdit={true}
      bulkEditFields={CUSTOMER_PRICING_TIERS_ALL_IN_TIERS_BULK_EDIT_FIELDS}
      maxBulkEditRows={maxBulkEditRows}
    />
  );
}
